import * as React from "react";
import clsx from "clsx";
import { AnalyticsTrigger } from "../../helpers/analytics/analytics-trigger/analytics-trigger.mjs";
import { Anchor } from "../../typography/anchor/anchor.mjs";
import { Button } from "../../button/button.mjs";
import { Chip } from "../../chip/chip.mjs";
import { FormHelper } from "../form-helper/form-helper.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { List } from "../../list/list/list.mjs";
import { ListItem } from "../../list/list-item/list-item.mjs";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
const FileField = (props) => {
  return /* @__PURE__ */ React.createElement(
    PropsChecker,
    {
      componentName: "FileField",
      componentProps: props,
      defaultValueName: "defaultValue",
      valueName: "value",
      onChangeNames: "onChange",
      isComponentDisabled: props.isDisabled
    },
    /* @__PURE__ */ React.createElement(
      PropsChecker,
      {
        componentName: "FileField",
        componentProps: props,
        defaultValueName: "defaultIsFocused",
        valueName: "isFocused",
        onChangeNames: ["onFocus", "onBlur"]
      },
      /* @__PURE__ */ React.createElement(
        AnalyticsTrigger,
        {
          trigger: [
            {
              callback: "onBrowse",
              id: "Field - Browse - ".concat(props.id),
              elementId: props.id,
              elementType: "browse",
              interactionType: "open"
            },
            {
              callback: "onChange",
              id: "Field - Select - ".concat(props.id),
              elementId: props.id,
              elementType: "browse",
              interactionType: "select"
            }
          ]
        },
        /* @__PURE__ */ React.createElement(FileFieldInner, { ...props })
      )
    )
  );
};
const _FileFieldInner = class _FileFieldInner extends React.Component {
  constructor(props) {
    super(props);
    this.input = null;
    this.onDrop = (event) => {
      event.preventDefault();
      const files = this.getFileList(event);
      if (!this.isFilesControlled()) {
        this.setState({
          files
        });
      }
      if (this.props.onChange) {
        this.props.onChange(event, files);
      }
    };
    this.onChange = (event) => {
      const files = this.getFileList(event);
      if (!this.isFilesControlled()) {
        this.setState({
          files
        });
      }
      if (this.props.onChange) {
        this.props.onChange(event, files);
      }
    };
    this.onRemove = (file) => {
      if (this.props.onRemove) {
        this.props.onRemove(file);
      }
    };
    this.onAdd = this.onAdd.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.state = {
      files: props.defaultFiles || {},
      isFocused: props.defaultIsFocused || false
    };
  }
  get files() {
    return this.isFilesControlled(this.props.files) ? this.props.files : this.state.files;
  }
  isFilesControlled(value = this.props.files) {
    const isDefined = typeof value !== "undefined";
    if (this.props.isDisabled) {
      return isDefined;
    }
    return !!this.props.onChange && isDefined;
  }
  isFocused(prop = this.props.isFocused, state = this.state.isFocused) {
    return this.isFocusControlled(prop) ? prop : state;
  }
  isFocusControlled(value = this.props.isFocused) {
    return !!this.props.onFocus && !!this.props.onBlur && typeof value !== "undefined";
  }
  isInvalid() {
    var _a;
    return (_a = this.props.isInvalid) != null ? _a : !!this.props.errorMessage;
  }
  onAdd() {
    if (this.input) {
      this.input.click();
    }
  }
  onFocus() {
    if (!this.isFocusControlled()) {
      this.setState({
        isFocused: true
      });
    }
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  }
  onBlur() {
    if (!this.isFocusControlled()) {
      this.setState({
        isFocused: false
      });
    }
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  }
  getLabel() {
    if (this.isFocused() && this.props.focusLabel) {
      return this.props.focusLabel;
    }
    return this.props.label;
  }
  getAriaDescribedBy() {
    const arr = [];
    if (this.props.helpMessage) {
      arr.push("".concat(this.props.id, "-help-message"));
    }
    if (this.props.errorMessage) {
      arr.push("".concat(this.props.id, "-error-message"));
    }
    if (this.props.successMessage) {
      arr.push("".concat(this.props.id, "-success-message"));
    }
    if (this.props.employeeMessage) {
      arr.push("".concat(this.props.id, "-employee-message"));
    }
    return arr.join(" ");
  }
  renderFiles() {
    const fileEntities = this.files;
    const files = Object.keys(fileEntities).map((name, i) => {
      return this.renderFile(fileEntities[name], i);
    });
    return /* @__PURE__ */ React.createElement(List, { type: "unstyled", direction: "inline", spacing: "large", className: "filefield__files" }, files);
  }
  renderFile(file, index) {
    return /* @__PURE__ */ React.createElement(ListItem, { key: index, className: "filefield__file" }, /* @__PURE__ */ React.createElement(
      Chip,
      {
        onRemove: file.removable ? this.onRemove.bind(this, file) : void 0,
        removeButtonLabel: this.props.removeButtonLabel,
        disabled: this.props.isDisabled
      },
      this.renderFileName(file)
    ));
  }
  renderFileName(file) {
    if (!file.anchor) {
      return file.name;
    }
    return /* @__PURE__ */ React.createElement(Anchor, { ...file.anchor, color: this.props.employee ? "employee" : void 0 }, file.name);
  }
  getFileList(event) {
    const fileEntities = {};
    let fileList = null;
    if ("dataTransfer" in event && event.dataTransfer) {
      const { files, items } = event.dataTransfer;
      if (files == null ? void 0 : files.length) {
        fileList = files;
      } else if (items == null ? void 0 : items.length) {
        fileList = items;
      }
    } else if (event.target && "files" in event.target) {
      fileList = event.target.files;
    }
    Array.prototype.slice.call(fileList).forEach(({ name }) => {
      fileEntities[name] = { name };
    });
    return fileEntities;
  }
  render() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: clsx(
          "filefield",
          {
            "is-disabled": this.props.isDisabled,
            "is-invalid": this.isInvalid(),
            "is-focused": this.isFocused(),
            "filefield--employee": this.props.employee,
            ["filefield--no-label-".concat(this.props.hideLabel)]: this.props.hideLabel
          },
          this.props.className
        )
      },
      /* @__PURE__ */ React.createElement("label", { className: "filefield__label", htmlFor: this.props.id }, this.props.employee && /* @__PURE__ */ React.createElement(Icon, { modifiers: "#support", className: "filefield__label-icon" }), this.getLabel()),
      this.props.helpMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: this.props.helpMessage, type: "help", id: "".concat(this.props.id, "-help-message") }),
      this.props.errorMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: this.props.errorMessage, type: "error", id: "".concat(this.props.id, "-error-message") }),
      this.props.successMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: this.props.successMessage, type: "valid", id: "".concat(this.props.id, "-success-message") }),
      this.props.employeeMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: this.props.employeeMessage, type: "employee", id: "".concat(this.props.id, "-employee-message") }),
      /* @__PURE__ */ React.createElement("div", { className: "filefield__inner" }, /* @__PURE__ */ React.createElement("div", { className: "filefield__input" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          ref: (input) => {
            this.input = input;
          },
          ...this.props.input,
          id: this.props.id,
          className: "filefield__input-field",
          type: "file",
          disabled: this.props.isDisabled,
          onChange: this.onChange,
          onDrop: this.onDrop,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          onClick: this.props.onBrowse,
          "aria-invalid": this.isInvalid(),
          "aria-describedby": this.getAriaDescribedBy(),
          "aria-required": this.props.required
        }
      ), this.renderFiles()), /* @__PURE__ */ React.createElement(
        Button,
        {
          className: "filefield__add-btn",
          iconLeft: "#upload",
          type: this.props.employee ? "employee" : void 0,
          text: this.props.addText,
          onClick: this.onAdd,
          disabled: this.props.isDisabled
        }
      ))
    );
  }
};
_FileFieldInner.defaultProps = {
  input: {
    multiple: true
  }
};
let FileFieldInner = _FileFieldInner;
export {
  FileField
};
